import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class CustomCompanyProductService {
    AppUrl: string = "";
    constructor(private readonly _httpClient: HttpClient) {
        this.setAPIUrl();
    }

    setAPIUrl() {
        if (sessionStorage.getItem("BaseURL") != null && sessionStorage.getItem("BaseURL") != "") {
            this.AppUrl = sessionStorage.getItem("BaseURL") || '';
        }
    }

    i360CustomCompanyProductAddUpdate(TokenKey: string, trainingModel: any): Observable<any> {
        this.setAPIUrl();
        let data = 'api/CustomProduct/AddUpdateCustomProduct';
        const httpOptions = { headers: new HttpHeaders({ 'Accept': 'application/json', 'Token': TokenKey }) };
        return this._httpClient.post<any>(this.AppUrl + data, trainingModel, httpOptions)
            .pipe(catchError(this.handleError));
    }

    i360CustomCompanyProductAddUpdateCustomData(TokenKey: string, trainingModel: any): Observable<any> {
        this.setAPIUrl();
        let data = 'api/CustomProduct/AddUpdateCustomData';
        const httpOptions = { headers: new HttpHeaders({ 'Accept': 'application/json', 'Token': TokenKey }) };
        return this._httpClient.post<any>(this.AppUrl + data, trainingModel, httpOptions)
            .pipe(catchError(this.handleError));
    }

    i360CustomProductGet(TokenKey: string, filterModel: any): Observable<any> {
        this.setAPIUrl();
        let data = 'api/CustomProduct/i360CustomProductGet';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._httpClient.post<any>(this.AppUrl + data, filterModel, httpOptions)
            .pipe(catchError(this.handleError));
    }

    i360CustomCompanyProductFindbycustomProductId(TokenKey: string, specialReportId: any): Observable<any> {
        this.setAPIUrl();
        let data = 'api/CustomProduct/i360CustomProductFindbyCustomProductId';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._httpClient.post<any>(this.AppUrl + data, specialReportId, httpOptions)
            .pipe(catchError(this.handleError));
    }

    i360CustomProductDelete(TokenKey: string, customProductId: any): Observable<any> {
        this.setAPIUrl();
        let data = 'api/CustomProduct/i360CustomProductDelete';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._httpClient.post<any>(this.AppUrl + data, customProductId, httpOptions)
            .pipe(catchError(this.handleError));
    }

    i360CustomProductitemDelete(TokenKey: string, customProductDetailsId: any): Observable<any> {
        this.setAPIUrl();
        let data = 'api/CustomProduct/i360CustomProductitemDelete';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._httpClient.post<any>(this.AppUrl + data, customProductDetailsId, httpOptions)
            .pipe(catchError(this.handleError));
    }

    private handleError(error: HttpErrorResponse) {
        console.error(error.message || error);
        return observableThrowError(() => error.status);
    }

    i360CustomProductDetailUpdate(TokenKey: string, currentIndexid: string, previousIndexid: string): Observable<any[]> {
        this.setAPIUrl();
        let data = 'api/CustomProduct/i360CustomProductDetailUpdate/' + currentIndexid + '/' + previousIndexid;
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
        return this._httpClient.get<any>(this.AppUrl + data, httpOptions)
            .pipe(catchError(this.handleError));
    }
}
